module.exports = __webpack_public_path__ + "static/media/discover.0968b15a.svg";